import { render, staticRenderFns } from "./qcDefaultField.vue?vue&type=template&id=b4980bde&scoped=true&"
import script from "./qcDefaultField.vue?vue&type=script&lang=js&"
export * from "./qcDefaultField.vue?vue&type=script&lang=js&"
import style0 from "./qcDefaultField.vue?vue&type=style&index=0&id=b4980bde&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4980bde",
  null
  
)

export default component.exports